/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/no-runloop, ember/require-tagless-components */
import { tracked } from '@glimmer/tracking';
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import { service } from '@ember/service';
import { later } from '@ember/runloop';

export default class WriteIntroModal extends Component {
  @service
  personOptions;

  // Required
  onExit = null;

  // Internal state
  @tracked isClosing = false;

  @computed('personOptions.hasAcknowledgedReportDisclaimer', 'isClosing')
  get isOpen() {
    return (
      !this.personOptions.hasAcknowledgedReportDisclaimer || this.isClosing
    );
  }

  @action
  dismiss() {
    this.personOptions.setHasAcknowledgedReportDisclaimer();
    this.isClosing = true;
    later(
      this,
      () => {
        if (this.isDestroyed || this.isDestroying) return;
        this.isClosing = false;
      },
      260,
    );
  }
}
